import api from './api';
import { DesktopInfo } from './guacamole.service';
import { ContentBlock } from '../types/blocks';

export interface PresentationStep {
  id: string;
  title: string;
  type: 'introduction' | 'web_app' | 'remote_desktop';
  orderIndex: number;
  targetUrl: string | null;
  estimatedTime: number | null;
  blocks: ContentBlock[];
  content: string;
  instructions: string;
  completionCriteria: string;
  environmentLabel: string | null;
  splitRatio: number;
}

export interface PresentationData {
  session: { id: string; name: string; status: string; studentCount: number };
  workshop: { id: string; title: string; description: string };
  steps: PresentationStep[];
}

export const presentationService = {
  getPresentationData: (sessionId: string): Promise<PresentationData> =>
    api.get(`/sessions/${sessionId}/presentation`).then((r) => r.data),

  getInstructorDesktop: (sessionId: string): Promise<DesktopInfo> =>
    api.get(`/sessions/${sessionId}/instructor-desktop`).then((r) => r.data),
};
